import { render } from "./EditIncident.vue?vue&type=template&id=54dbd3d2"
import script from "./EditIncident.vue?vue&type=script&lang=js"
export * from "./EditIncident.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__